<template>
    <div class="flex flex-row space-x-2">
        <div
            v-for="(source, index) in sources"
            :key="source"
            :class="hasMultipleFiles ? 'flex-1' : 'mx-auto'"
            @click="openLightBox(index)"
        >
            <AssetCdnImage
                :src="source"
                :object-fit="hasMultipleFiles ? 'cover' : 'contain'"
                :aspect-ratio="hasMultipleFiles ? '1/1' : undefined"
                layout="fullWidth"
                class="rounded"
            />
        </div>
        <Lightbox
            v-if="sources.length"
            v-model="showLightBox"
            :slide="slide"
            :sources="sources"
        />
    </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import type { PostFileResource } from '@/api/backend/resources/PostFileResource';
import Lightbox from '@/components/Lightbox';

export default defineComponent({
    name: 'PostImages',
    components: {
        Lightbox,
    },
    props: {
        /**
         * Image file objects
         */
        files: {
            type: Array as PropType<PostFileResource[]>,
            required: true,
        },
    },
    data() {
        return {
            showLightBox: false,
            slide: 1,
        };
    },
    computed: {
        sources() {
            return this.files.map((file) =>
                file.is_infected ? this.$t('assets.placeholder.infectedFile') : file.originalUrl,
            );
        },
        hasMultipleFiles() {
            return this.files.length > 1;
        },
    },
    methods: {
        openLightBox(index: number) {
            this.slide = index + 1;
            this.showLightBox = true;
        },
    },
});
</script>
